<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-menu ref="picker"
          v-model="picker"
          :close-on-content-click="false"
          :nudge-right="10"
          :nudge-top="0"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px" >
    <template v-slot:activator="{ on }">
      <InputField v-model="date"
                  :label="label"
                  readonly
                  v-on="on"/>
    </template>
    <v-date-picker v-model="date"
                   color="green"
                   no-title
                   scrollable
                   @input="close()"/>
  </v-menu>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import InputField from '@/components/InputField';

/**
 * Date picker.
 */
@Component({
  components: {
    InputField,
  },
  props: {
    value: {
      type:     [ String, Date, Number ],
      default:  '',
      required: false,
    },
    label: {
      type:     String,
      default:  'Pick a date',
      required: false,
    },
  },
})
export default class DatePicker extends Vue {
  /**
   * Mutable date.
   */
  mutableDate = null;

  /**
   * Picker dropdown show or hide.
   * @type {boolean}
   */
  picker = false;

  /**
   * Date getter.
   */
  get date() {
    return this.value;
  }

  /**
   * Date setter.
   * @param value - current date.
   */
  set date(value) {
    this.mutableDate = value;
  }

  /**
   * Close picker.
   */
  close() {
    this.picker = false;
    this.$emit('input', this.mutableDate);
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DatePicker.vue